// ArChat appIntlLocale
// Created: 15-04-2026 12:00:00
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Devuelve un tag BCP 47 estable para formatear fechas/números según el idioma activo de la app
 * (no forzar es-ES en pantallas de perfil / facturación).
 *
 * @param {string} [lang] - Código normalizado (ej. es, en, de, ar)
 * @returns {string}
 */
export function appLangToBcp47(lang) {
  const base = String(lang || 'es')
    .toLowerCase()
    .split(/[-_]/)[0]
    .trim();
  const map = {
    es: 'es-ES',
    en: 'en-US',
    pt: 'pt-BR',
    fr: 'fr-FR',
    de: 'de-DE',
    it: 'it-IT',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    el: 'el-GR',
    tr: 'tr-TR',
    ar: 'ar',
    he: 'he-IL',
    hi: 'hi-IN',
    ja: 'ja-JP',
    ko: 'ko-KR',
    zh: 'zh-CN',
  };
  if (map[base]) return map[base];
  if (typeof navigator !== 'undefined' && navigator.language) return navigator.language;
  return 'en-US';
}
